import { useState, useEffect } from "react";
import { Pen2, BellBing } from "@solar-icons/react/ssr";
import {
    Chip,
    Grid,
    IconButton,
    TextField,
    Tooltip,
    useTheme,
    useMediaQuery,
} from "@mui/material";
import { parse } from "date-fns";

import { request } from "@/Api";
import { ShadedBox } from "@/common/StyledComponents";

export default function Milestone({
    milestone,
    milestones,
    setMilestones,
    setPopupMilestone,
    readOnly,
}) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const [milestoneLocal, setMilestoneLocal] = useState(milestone);
    const [cache, setCache] = useState(null);

    const handleInput = (event) => {
        setMilestoneLocal({
            ...milestoneLocal,
            description: event.target.value,
        });
    };

    const handleFocus = (field) => () => {
        setCache(milestoneLocal[field]);
    };

    const handleBlur = (event) => {
        if (cache == event.target.value) {
            return;
        }

        request
            .put(`milestone/${milestone.id}`, {
                ...milestoneLocal,
                description: event.target.value,
            })
            .then((response) => {
                setMilestones(
                    milestones.map((milestone) => {
                        return milestone.id == response.data.id
                            ? response.data
                            : milestone;
                    }),
                );
            });
    };

    const handleMenuOpen = (event) => {
        setPopupMilestone({
            ...milestone,
            remind_date: milestone.remind_date
                ? parse(milestone.remind_date, "y-MM-dd", new Date())
                : null,
            complete_date: milestone.complete_date
                ? parse(milestone.complete_date, "y-MM-dd", new Date())
                : null,
        });
    };

    useEffect(() => {
        setMilestoneLocal(milestone);
    }, [milestone]);

    return (
        <ShadedBox
            backgroundColor={theme.palette.background.paper}
            style={{ padding: 15, margin: 0, marginBottom: 20 }}
        >
            <Grid
                container
                height={"100%"}
                spacing={2}
                flexWrap="nowrap"
                alignItems="stretch"
            >
                {!isMobile && (
                    <Grid item xs={0.3}>
                        <div
                            style={{
                                width: 10,
                                paddingTop: 10,
                                height: "100%",
                                boxSizing: "border-box",
                            }}
                        >
                            <div
                                style={{
                                    width: 10,
                                    height: 10,
                                    background:
                                        new Date(milestone.complete_date) <
                                        new Date()
                                            ? theme.palette.primary.main
                                            : theme.palette.text.primary,
                                    borderRadius: "50%",
                                }}
                            />
                            <div
                                style={{
                                    paddingTop: 5,
                                    height: "100%",
                                    width: "100%",
                                    boxSizing: "border-box",
                                    alignItems: "center",
                                    display: "flex",
                                    justifyContent: "center",
                                }}
                            >
                                <div
                                    style={{
                                        width: 1,
                                        background: theme.palette.text.primary,
                                        height: "calc(100% - 15px)",
                                    }}
                                />
                            </div>
                        </div>
                    </Grid>
                )}
                <Grid item xs={isMobile ? 12 : 11.7}>
                    <Grid container item justifyContent={"space-between"}>
                        <Grid item paddingBottom={1}>
                            <Grid container spacing={2} alignItems={"center"}>
                                <Grid item>{milestoneLocal.name}</Grid>
                                <Grid item>
                                    <Chip
                                        label={parse(
                                            milestone.complete_date,
                                            "y-MM-dd",
                                            new Date(),
                                        ).toDateString()}
                                        color="default"
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Grid container>
                                <Grid item padding={"5px"}>
                                    <Tooltip
                                        title={
                                            <div>
                                                <span>
                                                    {milestoneLocal.remind_date ||
                                                        "no reminder"}
                                                </span>
                                            </div>
                                        }
                                    >
                                        <BellBing
                                            color={
                                                milestoneLocal.remind_date
                                                    ? "success"
                                                    : "default"
                                            }
                                        />
                                    </Tooltip>
                                </Grid>
                                {readOnly ? null : (
                                    <Grid item>
                                        <IconButton
                                            size="small"
                                            onClick={handleMenuOpen}
                                        >
                                            <Pen2 />
                                        </IconButton>
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                    <TextField
                        size="small"
                        onChange={handleInput}
                        fullWidth
                        multiline
                        value={milestoneLocal.description}
                        onFocus={handleFocus("description")}
                        onBlur={handleBlur}
                        InputProps={{
                            readOnly: readOnly,
                        }}
                    />
                </Grid>
            </Grid>
        </ShadedBox>
    );
}
